<script setup lang="ts">
    import { Button } from '@/components/ui/button';
    import { ChevronRight } from 'lucide-vue-next';

    const props = defineProps<{
        link?: string;
        isConnected?: boolean;
    }>();

    const openLink = () => {
        window.open(props.link, '_blank');
    };
</script>

<template>
    <Button
        variant="ghost_primary"
        size="xs"
        width="narrow"
        @click="openLink"
    >
        {{ $t('viia.attach_bank') }}
        <ChevronRight class="text-primary" />
    </Button>
</template>
